document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.custom-testimonials.scroll-area').forEach((scrollArea) => {
		let isDown = false;
		let startX = 0;
		let scrollLeft = 0;

		scrollArea.addEventListener('mousedown', (e) => {
			isDown = true;
			scrollArea.classList.add('is-dragging');
			startX = e.pageX - scrollArea.offsetLeft;
			scrollLeft = scrollArea.scrollLeft;
		});

		scrollArea.addEventListener('mouseleave', () => {
			isDown = false;
			scrollArea.classList.remove('is-dragging');
		});

		scrollArea.addEventListener('mouseup', () => {
			isDown = false;
			scrollArea.classList.remove('is-dragging');
		});

		scrollArea.addEventListener('mousemove', (e) => {
			if (!isDown) return;
			e.preventDefault();

			const x = e.pageX - scrollArea.offsetLeft;
			const walk = (x - startX) * 1.2;
			scrollArea.scrollLeft = scrollLeft - walk;
		});
	});

	document.querySelectorAll('.custom-testimonials .review-text-wrapper').forEach((reviewTextWrapper) => {
		const textEl = reviewTextWrapper.querySelector('.review-text');
		const showBtn = reviewTextWrapper.querySelector('.show-more-btn');
		const lessBtn = reviewTextWrapper.querySelector('.show-less-btn');

		const isOverflowing = textEl.scrollHeight > textEl.clientHeight;
    if(isOverflowing) {
      showBtn.classList.remove('hidden');
    }

		showBtn.addEventListener('click', () => {
			textEl.classList.remove('collapsed');
			showBtn.classList.add('hidden');
			lessBtn.classList.remove('hidden');
		});

		lessBtn.addEventListener('click', () => {
			textEl.classList.add('collapsed');
			showBtn.classList.remove('hidden');
			lessBtn.classList.add('hidden');
		});
	});
});
